"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const isEmpty_1 = __importDefault(require("lodash/isEmpty"));
const shallow_1 = require("zustand/shallow");
const objectivesKeys_1 = __importDefault(require("consts/queryKeys/objectivesKeys"));
const RefetchQueryContext_1 = require("context/RefetchQueryContext");
const ReloadContext_1 = require("context/ReloadContext");
const UserContext_1 = require("context/UserContext");
const useObjective_1 = require("hooks/api/useObjective");
const useObjectives_1 = require("hooks/api/useObjectives");
const useAdjustWeightModal_1 = require("hooks/useAdjustWeightModal/useAdjustWeightModal");
const HelperUtils_1 = require("utils/HelperUtils");
const Modal_1 = __importDefault(require("components/design-system/Modal"));
const AdjustObjectiveList_1 = __importDefault(require("./AdjustObjectiveList"));
const CommentUpdate_1 = __importDefault(require("./CommentUpdate"));
const AdjustWeightModal = ({ eventOnClick: closeModal, eventOnUpdate, createCallback, customParams }) => {
    var _a, _b, _c;
    const { refetchQueries, refetchObjective, invalidateQueries, removeQueries } = (0, RefetchQueryContext_1.useRefetchQuery)();
    const { reload, reloadSidebar } = (0, ReloadContext_1.useReload)();
    const { config: { permissions: { approvalSee, objectiveWeightManage } } } = (0, UserContext_1.useUser)();
    const { isIndividual, isPercentage, isComplexity, isCreate, editedObjectivesData, payloadBody } = (0, useAdjustWeightModal_1.useAdjustWeightModalStore)((state) => ({
        isIndividual: state.isIndividual,
        isPercentage: state.isPercentage,
        isComplexity: state.isComplexity,
        isCreate: state.isCreate,
        editedObjectivesData: state.editedObjectivesData,
        payloadBody: state.payloadBody
    }), shallow_1.shallow);
    const [isModalComment, setIsModalComment] = (0, react_1.useState)(false);
    const isObjectivesWeightError = ((_a = editedObjectivesData === null || editedObjectivesData === void 0 ? void 0 : editedObjectivesData.filter((objective) => {
        return objective === null || objective === void 0 ? void 0 : objective.isWeightError;
    })) === null || _a === void 0 ? void 0 : _a.length) > 0;
    const updateWeightHandle = () => {
        if (isCreate) {
            // EVENT
            createCallback && createCallback(editedObjectivesData);
            closeModal();
        }
        else {
            setIsModalComment(true);
        }
    };
    const refetchData = (id) => __awaiter(void 0, void 0, void 0, function* () {
        yield refetchObjective(id);
        refetchQueries(['overallProgress']);
        eventOnUpdate && eventOnUpdate();
        if (isIndividual) {
            reload(Object.assign({ reloadSidebar: !reloadSidebar }, (approvalSee && {
                reloadApprovalPanel: ['edited']
            })));
        }
        else {
            reload({
                reloadSidebar: !reloadSidebar,
                reloadApprovalPanel: ['edited']
            });
        }
        if (!isComplexity) {
            removeQueries(objectivesKeys_1.default.objectives('adjustWeightModal'));
            invalidateQueries(objectivesKeys_1.default.totalObjectives());
        }
        closeModal();
    });
    const { mutate: saveWeight, isLoading: isUpdatingWeight } = (0, useObjectives_1.useEditBulkObjectives)();
    const { mutate: saveComplexity, isLoading: isUpdatingCompexity } = (0, useObjective_1.useEditSingleObjective)((_b = editedObjectivesData === null || editedObjectivesData === void 0 ? void 0 : editedObjectivesData[0]) === null || _b === void 0 ? void 0 : _b.id);
    const saveData = () => {
        if (isComplexity) {
            saveComplexity(payloadBody, {
                onSuccess: () => {
                    var _a;
                    refetchData((_a = editedObjectivesData === null || editedObjectivesData === void 0 ? void 0 : editedObjectivesData[0]) === null || _a === void 0 ? void 0 : _a.id);
                }
            });
        }
        else {
            saveWeight(payloadBody, {
                onSuccess: () => {
                    var _a;
                    (_a = payloadBody === null || payloadBody === void 0 ? void 0 : payloadBody.objectives) === null || _a === void 0 ? void 0 : _a.forEach(({ id }) => __awaiter(void 0, void 0, void 0, function* () {
                        refetchData(id);
                    }));
                }
            });
        }
    };
    return (react_1.default.createElement(Modal_1.default, { customClass: `cursor-default ${objectiveWeightManage ? 'w-[800px]' : 'w-[680px]'}`, onClose: closeModal, dataCy: "modal-adjust-weight" },
        react_1.default.createElement(Modal_1.default.Header, { title: (0, HelperUtils_1.getObjectiveLocale)(isModalComment
                ? 'Comment Update'
                : `Adjust objective ${isComplexity
                    ? 'complexity'
                    : !isPercentage
                        ? 'type'
                        : 'weighting'}`), customClass: "h-[72px] flex items-center mb-[4px]", onClose: closeModal, titleIcon: {
                name: isModalComment ? 'icon-keyboard_backspace' : '',
                onClick: () => setIsModalComment(false)
            } }),
        react_1.default.createElement(Modal_1.default.Body, null, isModalComment ? (react_1.default.createElement(CommentUpdate_1.default, null)) : (react_1.default.createElement(AdjustObjectiveList_1.default, { customParams: customParams }))),
        react_1.default.createElement(Modal_1.default.Footer, { primaryButton: {
                onClick: isModalComment ? saveData : updateWeightHandle,
                text: isModalComment
                    ? (0, HelperUtils_1.getObjectiveLocale)('Update')
                    : (0, HelperUtils_1.capitalize)((0, HelperUtils_1.getObjectiveLocale)('Update weight')),
                disabled: isModalComment
                    ? (0, isEmpty_1.default)(payloadBody === null || payloadBody === void 0 ? void 0 : payloadBody.comment)
                    : ((_c = payloadBody === null || payloadBody === void 0 ? void 0 : payloadBody.objectives) === null || _c === void 0 ? void 0 : _c.length) === 0 || isObjectivesWeightError,
                isLoading: isModalComment
                    ? isUpdatingWeight || isUpdatingCompexity
                    : false,
                dataCy: isModalComment ? 'set-adjust' : 'next-adjust'
            }, secondaryButton: {
                onClick: closeModal,
                text: 'Cancel',
                dataCy: 'cancel-adjust'
            }, useBorder: false, customClass: "mt-[4px]" })));
};
const AdjustWeightModalWrapper = (props) => {
    const { config } = (0, UserContext_1.useUser)();
    const isPercentage = (config === null || config === void 0 ? void 0 : config.objectiveWeightType) === 'percentage';
    return (react_1.default.createElement(useAdjustWeightModal_1.AdjustWeightModalProvider, { isIndividual: props.isIndividual, objectives: props.objectives, level: props.level, isCreate: props.isCreate, isPercentage: isPercentage, isSubGoal: props.isSubGoal, fromBadgeWeight: props.fromBadgeWeight, maxSumOfObjectivesOnBasedOnCategory: props.maxSumOfObjectivesOnBasedOnCategory, maxSumOfObjectivesBasedOnCategory: props.maxSumOfObjectivesBasedOnCategory },
        react_1.default.createElement(AdjustWeightModal, Object.assign({}, props))));
};
exports.default = AdjustWeightModalWrapper;
